/**
 * Sign In — court-exhibit auth shell (AuthLayout + AuthBrandPanel) wrapping the
 * Clerk <SignIn> widget. Branding panel + form styling live in components/auth;
 * this page only wires the Clerk widget + the signed-in redirect guard.
 */

import { SignIn, useUser } from '@clerk/clerk-react';
import { Navigate, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import { authClerkAppearance } from '../components/auth/clerkAppearance';

export default function SignInPage() {
  const { isSignedIn, isLoaded } = useUser();
  const [searchParams] = useSearchParams();
  // PR-2 (2026-07-12): AttorneyLoginRedirect sends attorneys here with
  // ?redirect_url=/attorney/workdesk so they land back on the WorkDesk
  // after Clerk auth instead of the general dashboard.
  const rawRedirect = searchParams.get('redirect_url') || '/';
  // In-app paths only — reject absolute/protocol-relative URLs so the param
  // can't act as an open redirect.
  const redirectTarget =
    rawRedirect.startsWith('/') && !rawRedirect.startsWith('//') ? rawRedirect : '/';

  if (isLoaded && isSignedIn) {
    return <Navigate to={redirectTarget} replace />;
  }

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Your matters and exhibits are where you left them."
      altPrompt="Don’t have an account?"
      altLinkText="Sign up"
      altLinkTo="/sign-up"
      securedNote="Secured by Clerk · encrypted in transit"
    >
      <SignIn
        routing="hash"
        signUpUrl="/sign-up"
        forceRedirectUrl={redirectTarget}
        appearance={authClerkAppearance}
      />
    </AuthLayout>
  );
}
